import React, { useEffect } from 'react';
import { useWhatsNew } from '../../hooks/useWhatsNew';
import { WhatsNewModal } from './WhatsNewModal';

// Expose preview() globally so Settings can trigger it without a reload
let _preview: (() => void) | null = null;
export const previewWhatsNew = () => _preview?.();

export const WhatsNewModalController: React.FC = () => {
  const { open, version, dismiss, preview } = useWhatsNew();

  useEffect(() => {
    _preview = preview;
    return () => { _preview = null; };
  }, [preview]);

  if (!open || !version) return null;

  return <WhatsNewModal version={version} onDismiss={dismiss} />;
};
